import { StatementOfCashFlow } from '../pages/StatementOfCashFlow/index.js';

const statementOfCashFlowRoute = {
  public: [],
  auth: [
    {
      name: 'statement_of_cash_flow',
      path: '/finance-and-accounting/statement-of-cash-flow',
      component: StatementOfCashFlow,
    },
  ],
};

export default statementOfCashFlowRoute;
